import { DownloadOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import ConsolePageWithHeader from '../../../layouts/ConsoleLayout/ConsolePageWithHeader';
import { useGiftVoucherDownloadModal } from './DownloadModal';
import GiftVoucherList from './GiftVoucherList';

const GiftVoucherListPage = () => {
    const { t } = useTranslation('giftVoucherList');
    const giftVoucherDownloadModal = useGiftVoucherDownloadModal();

    const extra = (
        <Button icon={<DownloadOutlined />} onClick={giftVoucherDownloadModal.open} type="primary">
            {t('giftVoucherList:actions.download')}
        </Button>
    );

    return (
        <ConsolePageWithHeader extra={extra} title={t('giftVoucherList:title')}>
            <GiftVoucherList />
            {giftVoucherDownloadModal.render({ forAdmin: true })}
        </ConsolePageWithHeader>
    );
};

export default GiftVoucherListPage;
